/*
 * @Author: JettyHuang
 * @LastEditors: JoanC-RB 15757871065@163.com
 * @Description:
 * @Date: 2021-03-03 18:15:48
 * @LastEditTime: 2024-06-17 17:46:12
 * @FilePath: /yft-b2c-web-h5/src/pages/Shop/Member/Wallet/MyWallet/MyWalletMod.js
 */
import { Modal, Toast } from 'antd-mobile';
import { observable, action, flow, computed } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';
import Serv from './NomalWalletServ';

class NomalWalletMod {
  @observable walletBalance = 0; // 钱包余额

  @observable walletBonus = 0; // 分红积分

  @observable commissionAmount = 0; //可转账消费

  @observable expectedProfit = 0; //不可用余额

  @observable hasBonus = false; //是否有分红积分

  @observable cisternBalance = 0; // 蓄水池余额

  @observable chargeAmountSum = 0; // 钱包累计充值金额

  @observable hasBoutique = false; // 是否有蒋璇钱包

  @observable hasInternational = false; // 是否有国际钱包

  @observable internationalBalance = 0; // 国际钱包余额

  @observable hasLianchuang = false; // 是否有联创钱包

  @observable lianchuangBalance = 0; // 联创钱包余额

  @observable latestTransaction = null; // 最新一项明细

  @observable totalCoupon = 0; // 优惠券数量

  @observable exchangeCouponCount = 0; // 产品兑换券数量

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @computed
  get isInternational() {
    const userInfo = Stores.AppMod.userInfo || {};
    return userInfo.areaCode && userInfo.areaCode !== '86';
  }

  /**
   * 获取钱包信息
   */
  getWalletInfo = flow(function* (isLY) {
    try {
      const { data } = yield Serv.getWalletInfo(isLY);
      if (data && data.length > 0) {
        for (const item of data) {
          const { accountType, usefulBalance, chargeAmountSum, commissionAmount, expectedProfit } =
            item;
          switch (accountType) {
            case 'NOMAL':
              this.walletBalance = usefulBalance || 0;
              this.chargeAmountSum = chargeAmountSum || 0;
              break;
            case 'CISTERN':
              this.cisternBalance = usefulBalance || 0;
              break;
            case 'BONUS':
              this.walletBonus = usefulBalance || 0;
              this.commissionAmount = commissionAmount || 0;
              this.expectedProfit = expectedProfit || 0;
              this.hasBonus = true;
              break;
            case 'BOUTIQUE': // 精选钱包
              this.hasBoutique = true;
              break;
            case 'INTERNATIONAL': // 国际钱包
              this.hasInternational = true;
              this.internationalBalance = usefulBalance || 0;
              break;
            case 'LIANCHUANG': // 联创钱包
              this.hasLianchuang = true;
              this.lianchuangBalance = usefulBalance || 0;
              break;
            default:
              break;
          }
        }
      }
    } catch (error) {}
  });

  /**
   * 获取最新一项明细
   */
  getLatestTransaction = flow(function* () {
    try {
      const { data } = yield Serv.getLatestTransaction();
      if (data && data.list) {
        this.latestTransaction = data.list[0];
      }
    } catch (error) {}
  });

  @action
  clearData() {
    this.walletBalance = 0;
    this.cisternBalance = 0;
    this.latestTransaction = null;
  }

  /**
   * 获取各种优惠券数量
   */
  getCouponCount = flow(function* () {
    const { data } = yield Serv.getCouponCount({
      userId: Stores.AppMod.userInfo.id
    });
    this.totalCoupon = 0;
    data.forEach((item) => {
      this.totalCoupon += item.count;
      if (item.couponType == 5) {
        this.exchangeCouponCount = item.count;
      }
    });
  });

  getUserShouldSupply = flow(function* ({ type, accountType, path, search, state, isTransfer }) {
    try {
      const { userInfo } = Stores.AppMod;
      const { cardCode } = userInfo || {};
      const res = yield Stores.PersonalMod.getUserShouldSupply();
      if (res) {
        Modal.alert('温馨提示', '请完善您的个人信息之后，再次发起转账，感谢您的配合！', [
          { text: '取消' },
          {
            text: '完善资料',
            onPress: () => {
              window.app.routerGoTo({
                pathname: '/personal/msgAdd',
                state: {
                  applyType: 3,
                  data: {
                    localCardCode: cardCode,
                    accountType,
                    type,
                    accumulate: 1
                  },
                  isTransfer
                }
              });
            }
          }
        ]);
        return;
      }
      window.app.routerGoTo({ pathname: path, search, state });
    } catch (error) {}
  });

  handleWithdrawal = flow(function* ({ type, accountType, path, search, state }) {
    try {
      const { userInfo } = Stores.AppMod;
      const { cardCode, belongSystem } = userInfo || {};
      const { resultCode, data } = yield Serv.getWithDrawList({
        pageSize: 10,
        pageNum: 1,
        accountTypeList: type,
        operateTypeList: '2,3',
        status: 'AUDITED'
      });
      if (resultCode === '0' && data && ((data.list && data.list.length === 0) || !data.list)) {
        const res1 = yield Serv.geCheckWithDraw();
        const checkWithDrawTime = res1.data;
        const { isPass, startClock, endClock, checkWithdrawPwd } = checkWithDrawTime || {};
        if (!isPass) {
          // 提现时间限制提示
          Toast.info(`提现时间为${startClock}到${endClock}`);
          return;
        }
        //获取完善资料权限
        const res2 = yield Stores.PersonalMod.getUserShouldSupply();
        if (res2) {
          Modal.alert('温馨提示', '请完善您的个人信息之后，再次发起提现，感谢您的配合！', [
            { text: '取消' },
            {
              text: '完善资料',
              onPress: () => {
                window.app.routerGoTo({
                  pathname: '/personal/msgAdd',
                  state: {
                    applyType: 3,
                    data: {
                      localCardCode: cardCode,
                      accumulate: 2,
                      goapply: 1,
                      accountType,
                      type,
                      checkWithDrawTime,
                      checkWithdrawPwd,
                      isRequire: !!this.isInternational
                    }
                  }
                });
              }
            }
          ]);
          return;
        }
        window.app.routerGoTo({
          pathname: '/member/wallet/withDraw/apply',
          clear: true,
          search: Util.encodeQuery({
            accountType,
            type,
            checkWithdrawPwd: checkWithDrawTime ? checkWithdrawPwd : ''
          })
        });
      } else {
        window.app.routerGoTo({ pathname: path, search, state });
      }
    } catch (e) {
      console.log('eeeeee', e);
    }
  });
}

const nomalWalletMod = new NomalWalletMod();
export default nomalWalletMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/NomalWallet/NomalWalletMod.js